import 'css-chunksrc/client/scenes/wbs/projectLoader/styles.scss';export default {
  "loader": "_loader_1dkun_1",
  "projectElement": "_projectElement_1dkun_5"
};